import React from 'react';
import ChipUi from '@material-ui/core/Chip';

const Chip = ({ label, size = 'medium', color = 'secondary', ...rest }) => {
  return <ChipUi size={size} label={label} color={color} {...rest} />;
};

export default Chip;
